export const data = {
	heading: '2021 год — год больших достижений',
	content:
		'В 2021 году мы «перезагрузили» компанию: запустили новые разработки и существенно доработали технологии на базе опыта нашей команды. У нас появилась полноценная IT-инфраструктура с полным автоматизированным циклом залогового кредитования.',
	card: {
		heading:
			'На базе собственных разработок запустили цифровой продукт для банков и финансовых компаний. ',
		content: [
			'Платформа состоит из различных модулей, которые автоматизируют процессы внутри организаций и повышают эффективность бизнеса.',
			'С помощью цифровых решений мы можем обеспечивать и сопровождать полноценный процесс залогового кредитования в любой организации: от заявки до онлайн-регистрации обременения в Росреестре и выпуска электронных закладных.',
		],
		link: {
			content: 'Узнать о платформе',
			href: 'https://creditclub.tech',
		},
	},
}
